export class LoginRequest {
  email: string;
  senha: string;
  tiposaas: number = 1;
}
